import {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import Layout from "../components/Layout";
import "./skillmatrix.css"
import {useSelector} from "react-redux";

const SuperVisorSkillMatrix = () => {
    const [skillMatrix, setSkillMatrix] = useState([])
    const [tableHeaders, setTableHeaders] = useState([])
    const [editedMatrix, setEditMatrix] = useState([])
    const {user} = useSelector(state => state["auth"])
    useEffect(() => {
        getMatrixData()
    }, [])

    const getMatrixData = () => {
        axios.get(BASE_URL + "/api/skillmatrix/GetMatrixData")
            .then(response => {
                const matrixList = response.data
                setSkillMatrix(matrixList)
                const headerList = Object.keys(matrixList.length !== 0 ? matrixList[0] : {})
                setTableHeaders(headerList)
            })
            .catch(e => console.log(e))
    }

    const onEditTextClick = e => {
        const obj = {}
        //const empCode = e.currentTarget.getAttribute("data-empcode")
        const registerId = e.currentTarget.getAttribute("data-registerid")
        const jsonKey = e.currentTarget.getAttribute("name")
        const value = e.currentTarget.value;

        if (value === "") {
            e.currentTarget.classList.add("text-error")
            return;
        } else if (parseInt(value) <= 0) {
            e.currentTarget.classList.add("text-error")
            return;
        } else {
            e.currentTarget.classList.remove("text-error")
        }
        const existArr = [...editedMatrix]

        obj["registerId"] = registerId.toString()
        obj["addedBy"] = user.registerID.toString()
        obj["matrixTitle"] = jsonKey
        obj["roleMatrixOpinionID"] = value

        const filteredMatrix = existArr.filter(data => data.matrixTitle === obj.matrixTitle && data.registerId === obj.registerId);
        if (filteredMatrix.length === 0) {
            setEditMatrix([...editedMatrix, obj]);
        } else {
            const existObj = filteredMatrix[0]
            const index = existArr.findIndex(obj => obj.matrixTitle === existObj.matrixTitle && obj.registerId === existObj.registerId);
            console.log(index)
            existObj.roleMatrixOpinionID = value
            existArr[index] = existObj
            setEditMatrix(existArr)

            /*  existObj.roleMatrixOpinionID = value
              const updatedMatrix = {...existObj}
              existArr.push(updatedMatrix)
              setEditMatrix(existArr);*/
        }

        /*   const empCode = e.currentTarget.getAttribute("data-empcode")
           const registerId = e.currentTarget.getAttribute("data-registerid")
           const jsonKey = e.currentTarget.getAttribute("name")
           const value = e.currentTarget.value;
           if (value === "") {
               e.currentTarget.classList.add("text-error")
               return;
           } else if (parseInt(value) <= 0) {
               e.currentTarget.classList.add("text-error")
               return;
           } else {
               e.currentTarget.classList.remove("text-error")
           }
           obj["registerId"] = registerId
           obj["addedBy"] = user.registerID
           obj[jsonKey] = value

           const filteredMatrix = editedMatrix.filter(data => data.registerId === registerId);
           if (filteredMatrix.length === 0) {
               setEditMatrix([...editedMatrix, obj]);
           } else {
               const existArr = editedMatrix.filter(data => data.registerId !== registerId);
               const existObj = filteredMatrix[0]
               existObj[jsonKey] = value
               const updatedMatrix = {...existObj}
               existArr.push(updatedMatrix)
               setEditMatrix(existArr);
           }*/

    }

    const onEditTextItemClick = e => {
        e.target.disabled = false
    }

    const saveMatrixChanges = () => {
        console.log(JSON.stringify(editedMatrix))
          axios.post(BASE_URL + `/api/skillmatrix/ProcessMatrixData`, JSON.stringify(editedMatrix))
              .then(response => {
                  console.log(response)
              }).catch(e => {
              console.log(e)
          })
    }

    const checkInputType = value => {
        switch (value) {
            case "RegisterID": {
                return true
            }
            case "EmployeeCode": {
                return true
            }
            case "EmployeeName": {
                return true
            }
            case "Department": {
                return true
            }
            case "Designation": {
                return true
            }
            default:
                return false
        }
    }


    return (
        <Layout>
            <div className="p-datatable p-component p-datatable-responsive-stack p-datatable-gridlines">
                <table className="p-datatable-table">
                    <thead className="p-datatable-thead">
                    <tr>{tableHeaders.map((value, index) => value === "RegisterID"? "" : <th role="columnheader" key={index} scope="col">
                        <div className="p-column-header-content"><span className="p-column-title">{value}</span></div>
                    </th>)}</tr>
                    </thead>
                    <tbody>
                    {skillMatrix.map((value, index) => (
                        <tr key={index}>
                            {tableHeaders.map((header, i) => header === "RegisterID" ? "" : <td key={i}>
                                    <input onClick={onEditTextItemClick}
                                           className="skill-matrix-input form-control"
                                           onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                           type={checkInputType(header) ? 'text' : 'number'}
                                           disabled={checkInputType(header)}
                                           data-registerid={value["RegisterID"]}
                                           data-empcode={value["EmployeeCode"]}
                                           name={header}
                                           onChange={onEditTextClick}
                                           defaultValue={value[header]}/>
                                </td>
                             )}
                        </tr>
                    ))}


                    </tbody>
                </table>
            </div>
            <button type="button" onClick={saveMatrixChanges} className="btn btn-primary">Save Changes</button>
        </Layout>
    )
}

export default SuperVisorSkillMatrix